angular.module("app").controller("EditProductController", [
    '$scope',
    'pageStatuses',
    'productsService',
    'logger',
    'errorHandler',
    'preloadedProductData',
    'deepCompare',
    '$stateParams',
    'settingsService',
    '$cookies',
    '$uibModalInstance',
    function ($scope,
              pageStatuses,
              productsService,
              logger,
              errorHandler,
              preloadedProductData,
              deepCompare,
              $stateParams,
              settingsService,
              $cookies,
              $modalInstance) {
        
        var settings =  settingsService.getSettings(),
            lang = $cookies.get("preferedLanguage") || settings.skin.defaultLang;
        var deletedImages = [];

        (init = function (data, selectedLanguage) {
            $scope.productData = angular.copy(data);
            $scope.productData.lang = selectedLanguage || lang;
            $scope.productData.images.splice(4);
        
        })(preloadedProductData);
        
        $scope.pageStatuses = pageStatuses;
        $scope.languages = settings.skin.languages;

        $scope.submitEditProductForm = function () {
            var changes = deepCompare.getChanges(angular.copy(preloadedProductData), $scope.productData);
            if (!changes && deletedImages.length === 0) {
                logger.logError("global.no_changes");
            }
            if (changes.images) {
                changes.images = changes.images.filter(function (item) {
                    return item !== null;
                });
            }

            if (changes.description != undefined && !changes.lang) {
                changes.lang = $scope.productData.lang;
            }
            if (deletedImages.length > 0) {
                changes.deleted_images = deletedImages;
            }

            var requestObj = {
                product: angular.copy(changes)
            };
            requestObj.product.id = $scope.productData.id;

            productsService.update(requestObj).then(
                function (response) {
                    if (response.status === "ok") {
                        updateScope(function() {logger.logSuccess("global.saved")});
                        $modalInstance.close();
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (error) {
                    errorHandler(error.message);
                }
            )

        };

        $scope.saveImage = function (productImage) {
            productsService.saveImage({
                productImage: {
                    image: angular.copy(productImage),
                    id: $scope.productData.id
                }
            }).then(
                function (response) {
                    if (response.status === "ok") {
                        updateScope(function() {logger.logSuccess("global.saved")});
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (error) {
                    errorHandler(error.message);
                }
            )
        };
        
        $scope.deleteImage = function (i, productImageId) {
            if (productImageId) {
                deletedImages.push(productImageId);
            }
            $scope.productData.images[i] = null;
        };

        $scope.getDescription = function (language) {
            productsService.getDescription({product_id: $scope.productData.id, lang: language}).then(
                function (response) {
                    if (response.status === "ok") {
                        $scope.productData.description = response.description;
                        $scope.productData.name = response.name;
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };
        
        function updateScope (cb) {
            productsService.getProducts({product_id: $scope.productData.id, lang: $scope.productData.lang}).then(
                function (response) {
                    if (response.status === "ok") {
                        init(response.product, $scope.productData.lang);
                        preloadedProductData = angular.copy($scope.productData);
                        cb && cb();
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        }

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
        
    }
    
]);